export default "__VITE_ASSET__7G8o8C4o__"